import React from 'react';
import { TableBlock } from '../TableBlock';
import { InstructionsToExtractors } from '../../shared/InstructionsToExtractors';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';
import { TableHeaderFields } from './settings/TableHeaderFields';
import styles from './TableEditorSettings.module.scss';
import { Link } from 'components/core';

export type TableEditorSettingsProps = {
  block: TableBlock & HydratedBlockProps;
  onChange: (updatedBlock: TableBlock) => void;
};

const Instructions = ({ instructions }: { instructions?: string[] }) => {
  if (!instructions || instructions.length === 0) {
    return null;
  }

  return (
    <div className={styles.instructionWrap}>
      {instructions.map((instruction, index) => (
        <p key={index} className={styles.instructionText}>
          {instruction}
        </p>
      ))}
    </div>
  );
};

const LinkToBestPractices = ({ link }: { link: string | undefined }) => {
  if (!link) {
    return null;
  }

  return (
    <Link to={link} component="a" variant="primary" external>
      Best practices for tables
    </Link>
  );
};

export const TableEditorSettings = ({
  block,
  onChange,
}: TableEditorSettingsProps) => {
  return (
    <div>
      <IconAndTitle icon={block.icon} title={block.title} />

      <Instructions instructions={block.instructions} />

      <LinkToBestPractices link={block.linkToBestPractices} />

      <hr />

      <InstructionsToExtractors block={block} onChange={onChange} />
      <hr />
      <TableHeaderFields
        block={block}
        onChange={onChange}
        headerType="column"
        formDescription="Columns"
      />
      <hr />
      <TableHeaderFields
        block={block}
        onChange={onChange}
        headerType="row"
        formDescription="Rows"
      />
      <hr />
    </div>
  );
};
